import React from 'react';
import { IProductCatalogItem, IProductCatalogQueryParamsForOrder, IQueryResult } from 'gen/ApiClient';

export interface IContext {
	params: IProductCatalogQueryParamsForOrder;
	setParams: React.Dispatch<React.SetStateAction<IProductCatalogQueryParamsForOrder>>;
	queryResult: IQueryResult<IProductCatalogItem> | undefined;
}

export const SearchProductCatalogItemsForOrderContext = React.createContext<IContext>(undefined as any);
